import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Config from "../../../Config";
import { useNavigate } from "react-router-dom";
import { color_grey_dark } from "../../../constants/colors";
import {
    AuthField,
    AuthForm,
    AuthFormHeader,
    AuthFormSubtitle,
    AuthFormTitle,
    AuthPrimaryButton,
} from "./AuthForm.styles";
import { useI18n } from "../../../i18n/I18nProvider";

const RecoverySubmitForm = ({ token }) => {
    const { t } = useI18n();
    const [submitted, setSubmitted] = useState(false);
    const formRef = useRef(null);
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
    } = useForm();

    const recoverySubmit = (data) => {
        if (data.newPassword !== data.newPasswordSubmit) {
            alert(t("Пароли не совпадают"));
            return;
        }
        axios.patch(Config.BACKEND_ADDR + "/auth/recovery", data = {
            token: token,
            password: data.newPassword,
        }).then((response) => {
            if (response.status !== 200) {
                alert(t("Непредвиденная ошибка при попытке восстановления пароля"));
            } else {
                setSubmitted(true);
                navigate("/service/personal/");
            }
        }).catch((err) => {
            if (err.status === 409) {
                alert(t("Данная ссылка на восстановление уже была использована"));
                return;
            }
            alert(t("Ошибка запроса на сервер приложения"));
        });
    };

    return (
        <AuthForm ref={formRef} onSubmit={handleSubmit((data) => recoverySubmit(data))}>
            <AuthFormHeader>
                <AuthFormTitle>
                    {submitted ? t("Пароль восстановлен") : t("Восстановление пароля")}
                </AuthFormTitle>
                <AuthFormSubtitle>
                    {submitted
                        ? t("Вы будете перенаправлены в личный кабинет")
                        : t("Придумайте новый пароль для входа")}
                </AuthFormSubtitle>
            </AuthFormHeader>
            {submitted ? (
                <p style={{ margin: 0, color: color_grey_dark, font: "400 14px/1.5 Onest, sans-serif" }}>
                    {t("Ваш пароль успешно восстановлен! Если переход не произошёл автоматически, обновите страницу.")}
                </p>
            ) : (
                <>
                    <AuthField>
                        {t("Пароль")}
                        <input
                            placeholder={t("Новый пароль")}
                            type="password"
                            autoComplete="new-password"
                            {...register("newPassword")}
                        />
                    </AuthField>
                    <AuthField>
                        {t("Повторите пароль")}
                        <input
                            placeholder={t("Повторите новый пароль")}
                            type="password"
                            autoComplete="new-password"
                            {...register("newPasswordSubmit")}
                        />
                    </AuthField>
                    <AuthPrimaryButton type="submit">
                        {t("Восстановить пароль")}
                    </AuthPrimaryButton>
                </>
            )}
        </AuthForm>
    );
};

export default RecoverySubmitForm;
